import { useSelector } from 'react-redux';

import { Input } from '@/components/Input';
import {
    selectRealEstateActiveIndex,
    selectRealEstatebyIndex,
    setRealEstateByIndex,
} from '@/context/borrower';
// eslint-disable-next-line no-restricted-imports
import { IRealEstate } from '@/context/borrower/types/realEstateAssetTypes';
// eslint-disable-next-line no-restricted-imports
// import { ICreditCard } from '@/context/borrower/types/creditCardsTypes';
import { RootState } from '@/context/store';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { getNumber } from '@/utils/valueFormat';

export interface IProps {
    baseId: string;
    showErrors: boolean;
    setShowErrors: (value: boolean) => void;
}

export const testId = 'RealEstateLoanBalance';

export function RealEstateLoanBalance({
    baseId,
    showErrors,
    setShowErrors,
}: IProps): JSX.Element {
    // ***** Redux *****
    const activeRealEstateIndex = useAppSelector(selectRealEstateActiveIndex);

    const realEstate = useSelector((state: RootState) =>
        selectRealEstatebyIndex(state, activeRealEstateIndex)
    );
    const loanBalance = realEstate?.loanBalance;
    const dispatch = useAppDispatch();
    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        setShowErrors(false);

        if (realEstate === null) return;
        if (typeof value !== 'string') return;
        const MAXIMUM = 999999999;
        const intValue: number | undefined = getNumber(value, MAXIMUM);
        if (intValue && intValue > MAXIMUM) return;
        if (realEstate === null) return;

        const newRealEstate: IRealEstate = {
            ...realEstate,
            loanBalance: intValue,
        };
        if (intValue && isNaN(intValue)) {
            newRealEstate.loanBalance = undefined;
        }
        dispatch(
            setRealEstateByIndex({
                index: activeRealEstateIndex,
                realEstate: newRealEstate,
            })
        );
    }

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <Input
                title='Balance'
                placeholder='320,000'
                showErrors={showErrors && !loanBalance}
                onChange={handleChange}
                id={`${baseId}-input-loanBalance`}
                value={loanBalance?.toLocaleString() ?? ''}
                prefix='$'
                showNumpad={true}
            />
        </div>
    );
}
